export default "__VITE_ASSET__f3e2afe6__"